import { Interface } from '../../../../../../FrontendBundle/Resources/js/ofcs';

export default new Interface({
    solve() {},
});
